export const locale = {
    lang: 'en',
    data: {
        MENU: {
            DASHBOARD: 'Dashboard',
            CONSIGNMENT_NOTES: 'Consignment Notes',
            INFORMATIONS: 'Informations',
            INFORMATION_BLOCKS: 'Information Blocks',
            PAYMENT_CREDITS: 'Payment Credits',
            CREDIT_COUNTED: 'Credit and Counted',
            RECEIVABLE: 'Receivable',
            ACCOUNTS_RECEIVABLE: 'Accounts Receivable',
            COUNTED: 'Counted',
            CREDITS: 'Credits',
            LIQUIDATIONS: 'Liquidations',
            BANKS: 'Banks',
            ATTENTION_CUSTOMERS: 'Attention Customers',
            REMISSIONS: 'Remissions',
            INVOICES: 'Invoices',
            DEBIT_NOTES: 'Debit Notes',
            COMPLEMENTS: 'Complements',
            CREDIT_NOTES: 'Credit Notes',
            CATALOGS: 'Catalogs',
            BRANCH_OFFICES: 'Branch Offices',
            PROVIDERS: 'Providers',
            OPERATORS: 'Operators',
            CUSTOMERS: 'Customers',
            PERSONS: 'Persons',
            TRAILERS: 'Trailers',
            TRUCKS: 'Trucks',
            PRODUCTS: 'Products',
            CATALOGUE: 'SAT Keys',
            INVOICE_TYPE: 'Invoice Types',
            USERS: 'Users',
            ROLES: 'Roles',
            CONFIGURATIONS: 'Configurations',
            LOCAL_TRAVELS: 'Local travels',
            FOREIGN_TRAVELS: 'Foreing travels'
        }
    }
}
